'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ponyfillGlobal = require('../../utils/esm/ponyfillGlobal.js');
var withTheme = require('./withTheme/withTheme.js');
var createGenerateClassName = require('./createGenerateClassName/createGenerateClassName.js');
var createStyles = require('./createStyles/createStyles.js');
var getThemeProps = require('./getThemeProps/getThemeProps.js');
var jssPreset = require('./jssPreset/jssPreset.js');
var makeStyles = require('./makeStyles/makeStyles.js');
var mergeClasses = require('./mergeClasses/mergeClasses.js');
var ServerStyleSheets = require('./ServerStyleSheets/ServerStyleSheets.js');
var styled = require('./styled/styled.js');
var StylesProvider = require('./StylesProvider/StylesProvider.js');
var ThemeProvider = require('./ThemeProvider/ThemeProvider.js');
var useTheme = require('./useTheme/useTheme.js');
var withStyles = require('./withStyles/withStyles.js');

/** @license Material-UI v4.9.14
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* Warning if there are several instances of @material-ui/styles */

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && typeof window !== 'undefined') {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}

exports.withTheme = withTheme["default"];
exports.withThemeCreator = withTheme.withThemeCreator;
exports.createGenerateClassName = createGenerateClassName;
exports.createStyles = createStyles;
exports.getThemeProps = getThemeProps;
exports.jssPreset = jssPreset;
exports.makeStyles = makeStyles;
exports.mergeClasses = mergeClasses;
exports.ServerStyleSheets = ServerStyleSheets;
exports.styled = styled;
exports.StylesContext = StylesProvider.StylesContext;
exports.StylesProvider = StylesProvider["default"];
exports.sheetsManager = StylesProvider.sheetsManager;
exports.ThemeProvider = ThemeProvider;
exports.useTheme = useTheme;
exports.withStyles = withStyles;
